/** Recipient tier aligned with AskPuntt invite picker tiers. */
export type AskPunttInviteRecipientTier =
  | "project"
  | "enterprise"
  | "new_email";

/** Surface that initiated the invitation. */
export type AskPunttInviteSurface =
  | "project_dialog"
  | "chat_dialog"
  | "agent_project"
  | "agent_chat";

export const ASK_PUNTT_INVITE_SENT_EVENT = "ask_puntt_invite_sent";

export interface AskPunttInviteSentPayload {
  senderUserId: string;
  senderEmail?: string;
  recipientUserIds: string[];
  recipientEmails: string[];
  recipientTiers: AskPunttInviteRecipientTier[];
  enterpriseId: string;
  enterpriseName?: string;
  projectId: string | null;
  projectName?: string;
  chatId?: string;
  surface: AskPunttInviteSurface;
}

/** Fire the canonical AskPuntt invite analytics event (once per batch). */
export function captureAskPunttInviteSent(
  capture: (event: string, properties?: Record<string, unknown>) => void,
  payload: AskPunttInviteSentPayload,
): void {
  capture(ASK_PUNTT_INVITE_SENT_EVENT, { ...payload });
}
